var map = {
	"./icons/244.svg": "9ac5",
	"./icons/290.svg": "03bd",
	"./icons/Logo_ined.svg": "ef7c",
	"./icons/Subtract.svg": "8777",
	"./icons/Vector.svg": "e455",
	"./icons/Vector_folder.svg": "674d",
	"./icons/add-file.svg": "dcab",
	"./icons/cancel.svg": "b463",
	"./icons/cursor.svg": "22a7",
	"./icons/edit-btn.svg": "aab5",
	"./icons/file-outline.svg": "ece1",
	"./icons/filter-outline.svg": "19cd",
	"./icons/forms2-4/Vector_lamp.svg": "377d",
	"./icons/left-bracket.svg": "6ba3",
	"./icons/loader.svg": "04ff",
	"./icons/menu.svg": "d17f",
	"./icons/navBar/Vector_nav_data.svg": "57f1",
	"./icons/navBar/Vector_nav_diagram.svg": "636f",
	"./icons/navBar/Vector_nav_graph.svg": "53a9",
	"./icons/navBar/Vector_nav_ok.svg": "e285",
	"./icons/navBar/Vector_nav_results.svg": "081c",
	"./icons/navBar/accreditation.svg": "3b40",
	"./icons/navBar/accreditation_approval.svg": "9c50",
	"./icons/navBar/approval.svg": "9de2",
	"./icons/navBar/bagage.svg": "c4e3",
	"./icons/navBar/briefcase-clock-outline.svg": "46d1",
	"./icons/navBar/briefcase-eye-outline.svg": "9184",
	"./icons/navBar/contacts_CO.svg": "191d",
	"./icons/navBar/contacts_region.svg": "d703",
	"./icons/navBar/convertBlock.svg": "3d4f",
	"./icons/navBar/graphs.svg": "0b66",
	"./icons/navBar/instructions.svg": "40fe",
	"./icons/navBar/license_info.svg": "f402",
	"./icons/navBar/lock.svg": "8dbd",
	"./icons/navBar/materials.svg": "54c7",
	"./icons/navBar/school-outline.svg": "d6c9",
	"./icons/navBar/settings.svg": "dd06",
	"./icons/pdf.svg": "5730",
	"./icons/profile.svg": "95dc",
	"./icons/sidebar-toggle-off.svg": "e86b",
	"./icons/sidebar-toggle-off_hover.svg": "558f",
	"./icons/sidebar-toggle-on.svg": "4a24",
	"./icons/sidebar-toggle-on_hover.svg": "41b2",
	"./icons/“.svg": "3e6d",
	"./images/Vector_rigth_arrow.svg": "5a5f",
	"./images/appeal_indicator.svg": "c167",
	"./images/arrow-down.svg": "76bd",
	"./images/arrow-up-down.svg": "374e",
	"./images/brackets/bracket-1.svg": "1a7f",
	"./images/brackets/bracket-10.svg": "3863",
	"./images/brackets/bracket-11.svg": "27d4",
	"./images/brackets/bracket-12.svg": "8659",
	"./images/brackets/bracket-13.svg": "aff3",
	"./images/brackets/bracket-14.svg": "d19b",
	"./images/brackets/bracket-2.svg": "2f4c",
	"./images/brackets/bracket-3.svg": "0ede",
	"./images/brackets/bracket-4.svg": "d013",
	"./images/brackets/bracket-5.svg": "b9b3",
	"./images/brackets/bracket-6.svg": "5bba",
	"./images/brackets/bracket-7.svg": "6c92",
	"./images/brackets/bracket-8.svg": "a328",
	"./images/brackets/bracket-9.svg": "2b8f",
	"./images/brackets/Скобка_general_value_bot.svg": "e715",
	"./images/brackets/Скобка_three_lines.svg": "6cc5",
	"./images/brackets/Скобка_two_lines.svg": "7c09",
	"./images/cancel.svg": "541d",
	"./images/ined_logo.svg": "83fd",
	"./img/arrowToRight.svg": "e33b",
	"./img/close.svg": "1d1b",
	"./img/logo.svg": "1ae4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";